function hueFromName(name: string) {
  const s = (name || "").trim().toLowerCase().slice(0, 4);
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 360;
  return h;
}

/** Pastel (za pozadine svijetle) */
export function catColors(name: string) {
  const h = hueFromName(name);
  return {
    bg: `hsl(${h} 85% 94%)`,
    border: `hsl(${h} 70% 70%)`,
    text: `hsl(${h} 45% 28%)`,
    shadow: `0 2px 10px hsla(${h} 70% 50% / 0.15)`,
  };
}

/** Solid (puna boja dugmadi kategorija) */
export function catSolidColors(name: string) {
  const h = hueFromName(name);
  // bazni ton + gradijent za “moderno”
  const base = `hsl(${h} 70% 48%)`;
  const top = `hsl(${h} 72% 54%)`;
  const hoverTop = `hsl(${h} 75% 58%)`;
  const activeTop = `hsl(${h} 80% 42%)`;
  return {
    grad: `linear-gradient(180deg, ${top} 0%, ${base} 100%)`,
    hoverGrad: `linear-gradient(180deg, ${hoverTop} 0%, ${base} 100%)`,
    activeGrad: `linear-gradient(180deg, ${activeTop} 0%, ${base} 100%)`,
    text: `#ffffff`,
    ring: `hsla(${h} 85% 40% / .45)`,
    shadow: `0 8px 20px hsla(${h} 70% 40% / .25)`,
    border: `1px solid hsla(${h} 70% 35% / .5)`,
  };
}
